export default __webpack_public_path__ + "assets/illustration1.4b6aab24.jpg";